const getters = {
  login (state) {
    return state.login
  },
  token (state) {
    return state.token
  },
  refreshToken (state) {
    return state.refreshToken
  }
}

export default getters
